import './Footer.css'

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <p className="footer__brand">Złota Rączka | Profesjonalne prace domowe w Warszawie i okolice</p>
        <p className="footer__contact">
          Kontakt: <a className="footer__contact-link" href="tel:+48574621560">+48 574 621 560</a>
        </p>
      </div>
    </footer>
  )
}

export default Footer
